import { Spin } from 'antd';
import React from 'react';

const FirstLoading = ({
  loading,
  loadedOk,
  loadingText = 'Cargando...',
  loadingContent,
  inicial = '',
  failed = 'No hay datos',
  children,
  ...props
}) => {
  switch (loading) {
    case true:
      return (
        <div style={props.style}>
          {loadingContent || (
            <Spin delay={500} tip={loadingText}>
              <div className="content" />
            </Spin>
          )}
        </div>
      );
    case false:
      return loadedOk ? children : failed;
    default:
      return <div style={props.style}>{inicial}</div>;
  }
};

export default FirstLoading;
